import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  quoteSummary: () => __(translations.quotationDetailsTab.quoteSummary, 'Quote summary'),
};
